//export const BASE_API_URL = "http://localhost:3000/v1";

export { BRISTOL } from "./bristols";

export const BASE_API_URL = "https://bathtrack-production.up.railway.app/v1";
